import DomainPage from "@/pages/solutions/DomainPage";

const config = {
  slug: "mental-health",
  name: "Mental Health, Substance Use & Crisis",
  ctaName: "mental health, substance use & crisis",
  h1: "Where are crisis calls concentrating — and where are the service deserts?",
  lede:
    "A small mental-health nonprofit writing a funding application can usually say only \"we believe there is need,\" because the evidence to prove it is locked behind expensive platforms or doesn't exist at community scale. Continuum's second domain brings the same place-based evidence layer — and the same honest pricing — to mental health, substance use, and crisis systems.",
  problem: [
    "How many crisis calls, overdose events, and shelter diversions is a community absorbing — and where do they cluster relative to the services meant to catch them? FCSS desks, PCNs, and municipal social-development offices are asked this by councils and funders, and today the honest answer is \"we don't have that mapped.\"",
    "Continuum's evidence base already holds the geocoded service registry and place-based need indicators this domain runs on — built once, during the housing rollout. Standing up mental health means pointing existing infrastructure at new indicators, not starting over.",
  ],
  evidenceBase: {
    heading: "No second platform to stand up.",
    headingAccent: "No second sales cycle.",
    body:
      "Municipalities and coalitions already on Continuum for housing don't re-onboard for mental health — the geocoded data, the priority-population lens, and the disparity method carry over, because the two systems overlap on population and geography. This domain sits directly beside the housing wedge: crisis, substance-use, and behavioural-health needs are already embedded in most homelessness counts and HNAs, and the same municipal FCSS and community-services desk that commissioned the HNA owns this file.",
  },
  produces: [
    "Community MH/SU profile — need, gaps, service map",
    "Crisis-system dashboard — calls, diversions, capacity",
    "Service-desert & disparity mapping",
    "Grant-ready evidence exports for small agencies",
  ],
  pricingNote:
    "Priced below the housing domain because these products aren't (yet) mandated by legislation. The full module catalog publishes as data sources are confirmed — the honesty architecture applies to the roadmap too.",
  pricingRows: [
    {
      product: "MH/SU Community Profile",
      status: "PLANNED",
      who: "FCSS desks, MH coalitions, PCNs",
      model: "Setup + annual refresh",
      price: "$8k–14k + $4k/yr",
    },
    {
      product: "Crisis System Dashboard",
      status: "PLANNED",
      who: "Municipalities, police services",
      model: "Subscription",
      price: "$12k–20k/yr + $5k setup",
    },
  ],
  faq: [
    {
      q: "When does this domain launch?",
      a: "No fixed date yet. Waitlist members get module releases, methodology drops, and pricing decisions as they're made — before general announcement.",
    },
    {
      q: "Do we need the housing module first?",
      a: "No. This domain will run standalone. Tenants already on housing get the shared evidence base included, since the population and geography overlap.",
    },
  ],
};

export default function MentalHealthDomain() {
  return <DomainPage config={config} />;
}
